import type { ILocation } from "@domain/General/Location/ILocation";
import { Location } from "@domain/General/Location/Location";
import { OfferTile, type IOffer, type IOfferDto } from ".";

export class Offer extends OfferTile implements IOffer
{
    
    description: string[];
    howItWorks: string[];
    terms: string[];
    advertiserAboutUs: string[];
    locations: ILocation[];
    location?: ILocation;
    offerType: string;
    isInstoreOffer: boolean;

    constructor( model: IOfferDto )
    {
        super( model );
        this.description = model.description ?? [];
        this.howItWorks = model.howItWorks ?? [];
        this.terms = model.terms ?? [];
        this.advertiserAboutUs = model.advertiserAboutUs ?? [];
        this.locations = model.locations?.map( l => new Location( l ) ) ?? [];
        this.location = this.locations.length > 0 ? this.locations[ 0 ] : undefined;
        this.offerType = model.offerType;
        this.isInstoreOffer = ( model.offerType ?? '' ).toLowerCase() == 'instore';
    }
    
    /**
     * True if it is an online offer
     */
    get isOnlineOffer()
    {
        return this.isInstoreOffer == false;
    }

}